//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios";

export default {
  name: 'home',
  components: {

  },
  data() {
    return {
      objTmp: {},
      iClaimKG: 0,
      iClaimYard: '',
      iClaimUOM: '',
      iGram: '',
      iClaimYard: '',
      iRemarkClaim: '',
      iAdditionBuyKG: '',
      iAdditionBuyYard: '',
      iAdditionRemark: '',
      sel_po: '',
      sel_so: '',
      sel_po_data: [],
      sel_po_filter: [],

      qtyPass: 0,
      sel_po_line: {},
      sel_po_line_data: [],
      sel_po_line_filter: [],

      showspiner1: false,
      showspiner2: false,

      dialog: false,
      current: 1,
      totalpage: 1,
      filter: '',
      searchby: 'ALL',
      weight: 0,
      claim: 0,
      data: [],
      option: [{
        value: 'ALL',
        label: 'All'
      }, {
        value: 'H.OU_CODE',
        label: 'OU'
      }, {
        value: 'FH.INS_NO',
        label: 'Ins. No'
      }, {
        value: 'FH.PL_NO',
        label: 'PL No.'
      }, {
        value: 'H.BATCH_NO',
        label: 'Batch No.'
      }, {
        value: 'FH.GRADE_NO',
        label: 'Grade'
      }, {
        value: 'H.SO_NO',
        label: 'SO'
      }, {
        value: 'H.ITEM_CODE',
        label: 'Item Code'
      }, {
        value: 'H.COLOR_CODE',
        label: 'Color Code'
      }, {
        value: 'DEMO.GET_NYG_SO(H.SO_NO)',
        label: 'NYG SO'
      }, {
        value: 'H.NYF_BUYER',
        label: 'Buyer'
      }, {
        value: 'FA.REF_PK_FG',
        label: 'Ref. FG PK'
      }, {
        value: 'H.NYF_CUS_PO',
        label: 'Customer PO'
      }, {
        value: 'FA.REF_INV_NO',
        label: 'Ref. Inv.'
      }],
      pagination: {
        sortBy: 'PK',
        descending: false,
        page: 1,
        rowsPerPage: 10
        // rowsNumber: xx if getting data from a server
      },
      columns: [{
          name: 'OU_CODE',
          align: 'left',
          label: 'OU',
          field: 'OU_CODE',
          sortable: true
        },
        {
          name: 'NYF_CUS_PO',
          label: 'Cus. PO',
          field: 'NYF_CUS_PO',
          sortable: true,
          align: 'left'
        },
        {
          name: 'PL_NO',
          label: 'PL No.',
          field: 'PL_NO',
          sortable: true,
          align: 'left'
        },
        {
          name: 'GRADE_NO',
          label: 'Grade',
          field: 'GRADE_NO',
          sortable: false,
          align: 'center'
        },
        {
          name: 'PL_KG',
          label: 'PL KG',
          sortable: false,
          field: 'PL_KG'
        },
        {
          name: 'APP_CAIM_KG',
          label: 'NYK Claim',
          field: 'APP_CAIM_KG',
          sortable: false,
          align: 'right'
        },
        {
          name: 'BATCH_NO',
          label: 'Batch No.',
          field: 'BATCH_NO',
          sortable: true,
          align: 'left'
        },

        {
          name: 'BATCH_KG',
          label: 'Batch KG',
          sortable: false,
          field: 'BATCH_KG'
        },
        {
          name: 'REF_PK_FG',
          label: 'PK No.',
          field: 'REF_PK_FG',
          sortable: true,
          align: 'left'
        }, {
          name: 'PK_SHIP_KG',
          label: 'FG KG',
          sortable: false,
          field: 'PK_SHIP_KG'
        }, {
          name: 'CUST_APP_CLAIM',
          label: 'Claim KG',
          sortable: false,
          field: 'CUST_APP_CLAIM'
        }, {
          name: 'NYG_SO_NO',
          label: 'NYG SO',
          field: 'NYG_SO_NO',
          sortable: true,
          align: 'left'
        }, {
          name: 'SO_NO',
          label: 'SO Prod.',
          field: 'SO_NO',
          sortable: true,
          align: 'left'
        }, {
          name: 'LINE_ID',
          label: 'Line',
          field: 'LINE_ID',
          sortable: false,
          align: 'center'

        }, {
          name: 'ITEM_CODE',
          label: 'Item Code',
          field: 'ITEM_CODE',
          sortable: true,
          align: 'left'
        }, {
          name: 'COLOR_CODE',
          label: 'Color Code',
          field: 'COLOR_CODE',
          sortable: true,
          align: 'left'
        }, {
          name: 'NYF_BUYER',
          label: 'Buyer',
          field: 'NYF_BUYER',
          sortable: true,
          align: 'left'
        }, {
          name: 'GRADE',
          label: 'Grade',
          field: 'GRADE',
          sortable: true,
          align: 'left'
        }
      ]
    }
  },
  mounted() {
    this.LoadData()
    // console.log(this.$store.getters.uid)
    // console.log(this.$store.getters.team)
  },
  computed: {
    percent() {
      return this.claim * 100 / this.weight
    },
    maxQty() {
      return 'Claim Quantity [Max = ' + this.qtyPass + ']'
    },
    ShowErrorLimit() {
      if (this.iClaimKG > this.qtyPass) {
        return ''
      } else {
        return ''
      }
    }
  },
  watch: {
    filter: function (newValue, oldValue) {
      //console.log(this.data)
    },
    iClaimKG: function (newValue, oldValue) {
      if (newValue == '') {
        this.iClaimYard = ''
      } else {
        if (this.iClaimUOM == 'KG') {
          let kg = parseFloat(newValue)
          let g = parseFloat(this.iGram)
          this.iClaimYard = Math.round((kg / g) * 1000 * 100) / 100
        } else {
          this.iClaimYard = newValue
        }
      }
    },
    iAdditionBuyKG: function (newValue, oldValue) {
      if (newValue == '') {
        this.iAdditionBuyYard = ''
      } else {
        if (this.iClaimUOM == 'KG') {
          let kg = parseFloat(newValue)
          let g = parseFloat(this.iGram)
          this.iAdditionBuyYard = Math.round((kg / g) * 1000 * 100) / 100
        } else {
          this.iAdditionBuyYard = newValue
        }
      }
    },
    sel_po: function (newValue, oldValue) {
      //console.log(newValue)
      if (newValue == '') {
        this.sel_po_line = {}
        this.sel_so = ''
        this.sel_po_line_data = []
      } else {
        if (newValue != oldValue) {
          this.sel_po_line = {}
          this.sel_po_line_data = []
          //console.log('Refresh PO Line1')
          this.LoadPOLine(newValue.BU, newValue.label)
        }
      }
    }
  },
  methods: {
    ChangePage() {
      this.pagination.page = this.current
      //console.log(this.current)
    },
    IsNumber(event) {
      if (!/\d/.test(event.key) && event.key !== '.') return event.preventDefault();
    },
    ShowData(event) {
      if (this.iClaimKG > this.qtyPass) {
        this.$q.notify({
          message: 'Claim Quantity more than Claim limit.',
          icon: 'error',
          color: 'red'
        })
      }

    },
    async LoadData() {

      let params = new FormData()
      params.append("uid", this.$store.getters.uid)
      params.append("field", this.searchby.value)
      params.append("txtsearch", this.filter)
      // params.append("job", this.sel_job)
      // params.append("itemcode", this.sel_itemcode)
      // params.append("so", this.sel_so)
      // params.append("machine", this.sel_machine)
      // params.append("batch", this.sel_batch)
      // params.append("vi", this.sel_vi)
      // params.append("customer", this.sel_customer)
      // params.append("appstatus", this.approveStatus)
      // params.append("color", this.sel_color)

      axios({
        method: "post",
        url: this.$api + "data_list.php",
        data: params
      }).then(res => {
        console.log(res.data)
        this.current = 1
        this.data = res.data.data
        this.weight = res.data.weight
        this.claim = res.data.claim
        this.totalpage = res.data.totalpage

        // const result = [];
        // const map = new Map();
        // for (const item of res.data.data) {
        //   if (!map.has(item.LOCATION)) {
        //     map.set(item.LOCATION, true); // set any value to Map
        //     result.push({
        //       id: item.LOCATION
        //     });
        //   }
        // }

        //console.log(result)
        //this.LoadPOHead(result[0].id)

      })

      await this.$nextTick(() => {
        // this.renderComponent = true
      })

    },

    async LoadPOHead(bu) {
      //console.log(bu + 'POHead')
      this.showspiner1 = true
      let params = new FormData()
      params.append("bu", bu)
      axios({
        method: "post",
        url: this.$api + "po_list.php",
        data: params
      }).then(res => {
        //console.log(res.data)
        this.sel_po_data = res.data
        this.showspiner1 = false
      })

      await this.$nextTick(() => {
        // this.renderComponent = true
      })

    },
    async LoadPOLine(bu, poHead) {
      //console.log(bu, poHead)
      this.showspiner2 = true
      let params = new FormData()
      params.append("bu", bu)
      params.append("NYG_POH_REC", poHead)
      axios({
        method: "post",
        url: this.$api + "po_line_list.php",
        data: params
      }).then(res => {
        //console.log(bu)
        // console.log(res.data)
        this.showspiner2 = false
        this.sel_po_line_data = res.data
      })

      await this.$nextTick(() => {
        // this.renderComponent = true
      })

    },
    async LoadQtyPass(ou, pl, shipkg) {
      //console.log(ou, pl)

      let params = new FormData()
      params.append("ou", ou)
      params.append("pl", pl)
      axios({
        method: "post",
        url: this.$api + "qtypass.php",
        data: params
      }).then(res => {
        //console.log(res.data)
        this.qtyPass = Math.round(parseFloat(res.data.perclaim) * 100 * shipkg / 100) / 100
      })

    },
    OpenDialog(obj) {
      this.dialog = true
      //console.log(obj)

      this.objTmp = obj

      this.iClaimKG = parseFloat(obj.CUST_APP_CLAIM)
      this.iClaimYard = ''
      this.iClaimUOM = obj.APP_CAIM_UOM
      this.iRemarkClaim = ''
      this.iGram = obj.WEIGHT_Y

      this.iAdditionBuyKG = ''
      this.iAdditionBuyYard = ''
      this.iAdditionRemark = ''
      this.sel_po = ''
      this.sel_po_line = {}
      this.sel_po_data = []
      this.sel_po_line_data = []

      this.LoadPOHead(obj.LOCATION)
      this.LoadQtyPass(obj.OU_CODE, obj.PL_NO, parseFloat(obj.PK_SHIP_KG))

    },

    UpdateClaim() {

      // if (this.objTmp.LOCATION == 'NYG1' || this.objTmp.LOCATION == 'NYG2' || this.objTmp.LOCATION == 'NYG3' || this.objTmp.LOCATION == 'NYG4') {

      // }

      let v = parseFloat(this.iClaimKG)

      if (v > parseFloat(this.objTmp.PK_SHIP_KG)) {
        this.$q.notify({
          message: 'Limit Claim!',
          icon: 'error',
          color: 'red'
        })
        return
      }

      // if (this.objTmp.GRADE != 'A') {
      //   if (v > this.qtyPass) {
      //     this.$q.notify({
      //       message: 'Limit Claim!',
      //       icon: 'error',
      //       color: 'red'
      //     })
      //     return
      //   }

      // }

      if (v > 0) {

        if (Object.entries(this.sel_po).length === 0 || Object.entries(this.sel_po_line).length === 0) {
          this.$q.notify({
            message: 'Please Fill PO No. & PO Line',
            icon: 'error',
            color: 'red'
          })
          return
        }
      }

      // console.log(this.iClaimKG)
      // console.log(this.objTmp)

      // console.log('sel_po', this.sel_po)
      // console.log('sel_po_line', this.sel_po_line)

      let params = new FormData()
      params.append("ou", this.objTmp.OU_CODE)
      params.append("pl", this.objTmp.PL_NO)
      params.append("batch", this.objTmp.BATCH_NO)
      params.append("apply", this.$store.getters.uid)
      params.append("claim_kg", this.iClaimKG)
      params.append("cusid", this.objTmp.CUSTOMER_ID)
      params.append("mailsale", this.objTmp.SALE_EMAIL)
      params.append("loc", this.objTmp.LOCATION)
      params.append("ins_no", this.objTmp.INS_NO)
      params.append("so_no", this.objTmp.SO_NO)
      params.append("ref_pk", this.objTmp.REF_PK_FG)
      params.append("ref_inv", this.objTmp.REF_INV_NO)
      params.append("buyer", this.objTmp.NYF_BUYER)
      params.append("sonyg", this.sel_po.SO_NO)
      params.append("color", this.objTmp.COLOR_CODE)
      params.append("uom", this.objTmp.APP_CAIM_UOM)
      params.append("addition", this.iAdditionBuyKG)
      params.append("comment1", this.iRemarkClaim)
      params.append("comment2", this.iAdditionRemark)

      params.append("NYG_POH_REC", this.sel_po.NYG_POH_REC)
      params.append("NYG_POH_ID", this.sel_po.NYG_POH_ID)
      params.append("NYG_POH_ORG", this.sel_po.NYG_POH_ORG)
      params.append("NYG_POL_REC", this.sel_po_line.NYG_POL_REC)
      params.append("NYG_POL_ID", this.sel_po_line.NYG_POL_ID)
      params.append("NYG_POL_ITEM", this.sel_po_line.NYG_POL_ITEM)
      params.append("NYG_POL_COLOR", this.sel_po_line.NYG_POL_COLOR)
      params.append("NYG_POL_SIZE", this.sel_po_line.NYG_POL_SIZE)

      axios({
        method: "post",
        url: this.$api + "updateclaim.php",
        data: params
      }).then(res => {

        if (res.data.success > 0) {
          this.SendMail(res.data)
          this.$q.notify({
            message: 'Update Claim Success.',
            icon: 'error',
            color: 'green'
          })
          this.dialog = false
          this.LoadData()
        } else {
          this.$q.notify({
            message: 'Update Claim Error.',
            icon: 'error',
            color: 'red'
          })
        }

      })

    },

    SendMail(mail) {

      console.log(mail)
      let params = new FormData()
      params.append("fromname", mail.fromname)
      params.append("frommail", mail.frommail)
      // params.append("mailto", "kaweewat.k@gmail.com")
      // params.append("mailcc", "kaweewat.k@gmail.com")
      // params.append("mailsale", "kaweewat.k@gmail.com")

      params.append("mailto", mail.mailto)
      params.append("mailcc", mail.mailcc)
      params.append("mailsale", mail.mailsale)

      params.append("subject", mail.subject)
      params.append("template", "FC")
      params.append("sysdate", mail.sysdate)

      params.append("ou", this.objTmp.OU_CODE)
      params.append("pl", this.objTmp.PL_NO)
      params.append("batch", this.objTmp.BATCH_NO)
      params.append("apply", this.$store.getters.uid)
      params.append("claim_kg", this.iClaimKG)
      params.append("cusid", this.objTmp.CUSTOMER_ID)
      params.append("mailsale", this.objTmp.SALE_EMAIL)
      params.append("loc", this.objTmp.LOCATION)
      params.append("ins_no", this.objTmp.INS_NO)
      params.append("so_no", this.objTmp.SO_NO)
      params.append("ref_pk", this.objTmp.REF_PK_FG)
      params.append("ref_inv", this.objTmp.REF_INV_NO)
      params.append("buyer", this.objTmp.NYF_BUYER)
      params.append("sonyg", this.sel_po.SO_NO)
      //console.log(this.sel_po.SO_NO)
      params.append("color", this.objTmp.COLOR_CODE)
      params.append("uom", this.objTmp.APP_CAIM_UOM)
      params.append("addition", this.iAdditionBuyKG)
      params.append("comment1", this.iRemarkClaim)
      params.append("comment2", this.iAdditionRemark)

      params.append("NYG_POH_REC", this.sel_po.NYG_POH_REC)
      params.append("NYG_POH_ID", this.sel_po.NYG_POH_ID)
      params.append("NYG_POH_ORG", this.sel_po.NYG_POH_ORG)
      params.append("NYG_POL_REC", this.sel_po_line.NYG_POL_REC)
      params.append("NYG_POL_ID", this.sel_po_line.NYG_POL_ID)
      params.append("NYG_POL_ITEM", this.sel_po_line.NYG_POL_ITEM)
      params.append("NYG_POL_COLOR", this.sel_po_line.NYG_POL_COLOR)
      params.append("NYG_POL_SIZE", this.sel_po_line.NYG_POL_SIZE)

      axios({
        method: "post",
        // url: "http://peoplefinder.nanyangtextile.com/service/Authen.asmx/SendMail",
        url: "http://peoplefinder.nanyangtextile.com/service/MailService.asmx/SendMail",
        data: params
      }).then(res => {
        //console.log(res.data)

      })

    },

    filterPO(val, update) {
      update(() => {
        if (val === '') {
          this.sel_po_filter = this.sel_po_data
        } else {
          const needle = val.toLowerCase()
          this.sel_po_filter = this.sel_po_data.filter(
            v => v.label.toLowerCase().indexOf(needle) > -1
          )
        }
      })
    }
  }

}
